export const optionsPF = [
  {label: 'Devedor', value: "15" },
  {label: 'Avalista', value: "16" },
];

export const optionsPJ = [
  {label: 'Adiantamentos a depositantes', value: "AD" },
  {label: 'Empréstimo/Financiamento Agrícola', value: "AG" },
  {label: 'Aluguel', value: "AL" },
  {label: 'Arrendamento, inclusive Leasing', value: "AR" },
  {label: 'Consórcio Imóvel', value: "C1" },
  {label: 'Consórcio Veículos Pesados', value: "C2" },
  {label: 'Consórcio Veículos', value: "C3" },
  {label: 'Consórcio Motocicletas', value: "C4" },
  {label: 'Consórcio oturos bens Móveis', value: "C5" },
  {label: 'Consórcio passagens Aéreas', value: "C6" },
  {label: 'Operações de Financiamento de Câmbio', value: "CA" },
  {label: 'Contrato de Câmbio', value: "CB" },
  {label: 'Conta Condominal', value: "CC" },
  {label: 'Cheque', value: "CH" },
  {label: 'Cédula de Crédito Industrial', value: "CI" },
  {label: 'Consórcio Contemplado', value: "CO" },
  {label: 'Crédito Pessoal', value: "CP" },
  {label: 'Cédula Rural Pignoratícia', value: "CR" },
  {label: 'Contratos (Diversos)', value: "CS" },
  {label: 'Operações com Cartão de Crédito', value: "CT" },
  {label: 'Dívidas Originárias de Cheques', value: "DC" },
  {label: 'Debêntures', value: "DB" },
  {label: 'Dívidas Originárias de Cheque Eletrônico', value: "DE" },
  {label: 'Duplicata', value: "DP" },
  {label: 'Empréstimo em conta, conta corrente garantida, e etc...', value: "EC" },
  {label: 'Energia Elétrica', value: "EE" },
];